import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import './style.css';
import { hideToast } from 'store/platform/actions';
import { DESIGN_CONFIG } from 'utils';
import AppIcon from 'asset/icons/AppIcon';
import { rdAssetIcons } from 'asset/icons';

function Toast() {
  const toastState = useSelector((state) => state.platform);

  const dispatch = useDispatch();

  useEffect(() => {
    if (toastState.show && !toastState.persistent) {
      const timer = setTimeout(() => {
        dispatch(hideToast());
      }, toastState.duration);

      return () => clearTimeout(timer);
    }
  }, [toastState.show, toastState.duration, toastState.persistent, dispatch]);

  const getToastIcon = () => {
    if (toastState.type === 'success') {
      return <AppIcon
        name={rdAssetIcons.notification}
        color={DESIGN_CONFIG.color.neutral.neutral500}
        size={24}
      />;
    }
    return <AppIcon
      color={DESIGN_CONFIG.color.neutral.neutral500}
      name={rdAssetIcons.alert}
      size={24}
    />;
  };

  return (
    <div
      className={`toast ${toastState.show ? 'show' : 'hide'} toast-${toastState.type}`}
      data-testid='toast'
    >
      {getToastIcon()}
      <p>{toastState.message}</p>
      {toastState.closable && (
        <AppIcon
          name={rdAssetIcons.close}
          className='toast-close'
          color='white'
          onClick={() => dispatch(hideToast())}
          size={20}
        />
      )}
    </div>
  );
}

export default Toast;
